import cn from 'classnames'
import config from '../../../config.json'

export const PreviewRender = ({
    calculateRenderHashes,
    isIllegalCombination,
}) => {
    return (
        <div className="flex justify-center h-92 relative mb-5">
            <div className="w-92 h-92 rounded-md bg-gray-200 -z-1 absolute" />
            <div
                className={cn(
                    'w-92 h-92 rounded-md bg-transparent z-100 absolute border-4',
                    isIllegalCombination()
                        ? 'border-red-700'
                        : 'border-transparent',
                )}
            />
            {calculateRenderHashes().map((hash) => (
                <div className="h-92 absolute">
                    <img
                        src={config.ipfs + hash.ipfs}
                        key={config.ipfs + hash.ipfs}
                        className="h-92"
                    />
                </div>
            ))}
        </div>
    )
}
